/**
 * Bot metadata, with no link to the search code.
 *
 * The UI needs names and descriptions to build a difficulty picker, but the
 * actual search only ever runs in a Web Worker. Importing the bot objects for
 * their labels pulled every evaluator and search routine into the main bundle
 * as well, so the labels live here on their own.
 *
 * `bots.test.ts` asserts this stays in step with the real implementations.
 */

export interface BotInfo {
  readonly id: string;
  readonly name: string;
  readonly level: 1 | 2 | 3 | 4;
  readonly description: string;
}

export const botCatalog: readonly BotInfo[] = [
  {
    id: 'random',
    name: 'Random',
    level: 1,
    description: 'Plays any legal move at random.',
  },
  {
    id: 'heuristic',
    name: 'Casual',
    level: 2,
    description: 'Takes and blocks mini-boards, and avoids handing over free moves.',
  },
  {
    id: 'minimax',
    name: 'Sharp',
    level: 3,
    description: 'Searches several moves ahead with alpha-beta pruning.',
  },
  {
    id: 'mcts',
    name: 'Ruthless',
    level: 4,
    description: 'Simulates thousands of games to find the strongest move.',
  },
];
